module.exports = __webpack_public_path__ + "static/image/history/m/202302@3x.ver2_0_2.jpg?e792f6f7";